import { IconButton, InputBase, Typography } from "@mui/material";

import { Box, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import CustomButtonSmall from "../../components/CustomButtonSmall";
import Grid from "@mui/material/Unstable_Grid2";
import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import ConnectionStatus from "../../utils/ConnectionStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import { getFromLocalStorage } from "../../utils/localStorageUtils";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import { useAtom } from "jotai";
import * as CONSTANT from "../../constants/Constant";
import SearchIcon from "@mui/icons-material/Search";

import { 
  globalSearchText, 
  selectedItems,
  showErrorAlertDialog, 
} from "../../config/AppConfig";
import { 
  ALERT,
  ERROR_WHILE_FETCHING_DATA,
  LOADING_PLEASE_WAIT,
  NO_INTERNET_CONNECTION_FOUND,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
  ADDING_EARMARK,
  LOADING_TIMELINE,
  ERROR,
  SOME_ERROR_OCCURRED,
} from "../../constants/Strings";
import DebugLog from "../../utils/DebugLog";
import {
  LOGIN_ID,
  MESSAGE_KEY,
  SESSION_ID,
  USER_NAME,
} from "../../constants/LocalStorageKeyValuePairString";
import {
  generateRandomId,
  generateRequestId,
} from "../../utils/RequestIdGenerator";

// API Services
import { 
  getAllAccountsEarMarkDetails,
  addEarmarkDetails,
  updateEarMarkDetails,
  deleteEarMarkDetails,
  getEarMarkTimelineDetails,
 } from "../../services/ApiService";

import { useNavigate } from "react-router-dom";
import { allAccountsEarmarkColumnHeader } from "../../components/ColumnHeader";
import NoDataFound from "../../components/NoDataFound";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";
import UserActivityInfo from "../../components/UserActivity";
import { initializeEncryption } from "../../services/AesGcmEncryption";
import AddEarmarkDialogInput from "./AddEarmarkDialog";
import SaveAndRemoveEarmarkDialog from "./SaveAndRemoveEarmarkDialog";
import ToolbarFilterButton from "../../components/ToolbarFilterButton";
import DatePickerDropdownButton from "../../components/DatePickerDropdownButton";

// Filter Configurations to be passed to SearchBarFilter in SectionHeader
const filterProps = [
  {
      keyValue: 'NAME',
      displayName: 'Name',
      paramName: 'accountName',
      isDateFilter: false,
      isSearchBarDropdown: false,
      searchBarDropdownOptions: [],
  },
  {
      keyValue: 'DEALER_CODE',
      displayName: 'Code',
      paramName: 'accountCode',
      isDateFilter: false,
      isSearchBarDropdown: false,
      searchBarDropdownOptions: [],
  },
];

export function AddDealerScreen() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  const isNetworkConnectionAvailable = UseOnlineStatus();

  // filterCriteria is fetched from API and has the structure of [{ "displayName": "NAME", "paramName": "accountName" }]
  const [filter, setFilter] = useState("");
  const [filterCriteria, setFilterCriteria] = useState([{ "keyValue":"","displayName": "", "paramName": "" }]);
  const [filterDisplayOptions, setFilterDisplayOptions] = useState([]);
  const [defaultFilter, setDefaultFilter] = useState("Name");
  const [isDateFilterSelected, setIsDateFilterSelected] = useState(false);

  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");

  const [earmarkDetails, setEarmarkDetails] = useState([]);
  const [searchInitiated, setSearchInitiated] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(0); // Used to set the height of the grid

  const [paginationModel, setPaginationModel] = useState({
    pageSize: 25,
    page: 0,
  });
  const [pageSize, setPageSize] = useState(25);
  const [totalNoOfRows, setTotalNoOfRows] = useState(0);
  const [totalNoOfPages, setTotalNoOfPages] = useState(0);

  const [searchQueryPlaceholder, setSearchQueryPlaceholder] = useState("Search Name");
  const [searchQuery, setSearchQuery] = useAtom(globalSearchText);

  const [searchDealerQuery, setDealerSearchQuery] = useState(""); //useAtom(globalSearchText);

  // Add Earmark Dialog
  const [openAddEarmarkDialog, setOpenAddEarmarkDialog] = useState(false);
  const [selectedDealerName, setSelectedDealerName] = useState("");
  const [selectedDealerCode, setSelectedDealerCode] = useState("");

  // Save and Remove Earmark Dialog
  const [openSaveAndRemoveEarmarkDialog, setOpenSaveAndRemoveEarmarkDialog] = useState(false);
  const [selectedItem, setSelectedItem] = useAtom(selectedItems);
  const [earmarkTimelineDetails, setearmarkTimelineDetails] = useState([]);

  // pagination for Timeline
  const [timelinePageSize, setTimelinePageSize] = useState(8);
  const [timelineCurrentPage, setTimelineCurrentPage] = useState(0);
  const [timelineTotalNoOfPages, setTimelineTotalNoOfPages] = useState(0);

  // useEffect(() => {
  //   getDataGridHeight();
  //   }, [pageSize]);

  // useEffect(() => {
  //   setPageSize(paginationModel.pageSize);
  //   searchAllAccountEarmarkDetails(paginationModel.page);
  // }, [paginationModel]);
  
  // call only on the first time page is rendered to update filter criteria
  useEffect(() => {
    // Set the filter criteria in the state
    setFilterCriteria(filterProps);
    setFilterDisplayOptions(filterProps.map((item) => item.displayName));
    setDefaultFilter(filterProps[0].displayName);
    setFilter(filterProps[0]);
  }, []);

  useEffect(() => {
    showNoInternetSnackBar();

    navigate(blockNavigation);
  }, [isNetworkConnectionAvailable, enqueueSnackbar, navigate, rowsPerPage]);

  // create useEffect to clear search query when a new filter is selected
  useEffect(() => {
    const placeholder = "Search " + filter.displayName;
    setSearchQueryPlaceholder(placeholder);
    setDealerSearchQuery("")
  }, [filter]);

  const handleOpen = () => {
    setOpenAddEarmarkDialog(true);
  };

  const handleFilterChange = (filter) => {
    // find the right filterCriteria based on the selected filter
    const selectedFilter = filterCriteria.find((item) => item.displayName === filter);
    setFilter(selectedFilter);

    // manage if filter is date filter
    if (selectedFilter.isDateFilter) {
      setIsDateFilterSelected(true);
    } else {
      setIsDateFilterSelected(false);
    }

  };

  const handleClose = () => {
    setOpenAddEarmarkDialog(false);
    DebugLog("Dialog Closed");
  };
  
  const handleCloseSaveAndRemoveEarmarkDialog = () => {
    setOpenSaveAndRemoveEarmarkDialog(false);
    DebugLog("Dialog Closed");
  };

  /********  Pagination Methods ***********/
  const handlePageJump = (event) => {
    const newPage = parseInt(event.target.value, 10) - 1;
    setPaginationModel({ pageSize: pageSize, page: newPage });

    // Avoid using state directly for API call as the state update function is async. 
    // Means it will not update the state immediately and it will be using the old state value.
    searchAllAccountEarmarkDetails(newPage, paginationModel.pageSize, filter, searchDealerQuery);
  };

  const handlePageChange = (newPage) => {
    setPaginationModel({ pageSize: pageSize, page: newPage });

    searchAllAccountEarmarkDetails(newPage, paginationModel.pageSize, filter, searchDealerQuery);
  };

  const handlePageSizeChange = (newPageSize) => {
    // keep pageSize in sync with the paginationModel
    setPageSize(newPageSize);
    setPaginationModel({ pageSize: newPageSize, page: 0 });

    // call api with new page size and start from page 0. 
    searchAllAccountEarmarkDetails(0, newPageSize, filter, searchDealerQuery);
  }

  /********  Timeline Pagination Methods ***********/
  const handleTimelinePageChange = (newPage) => {
    setTimelineCurrentPage(newPage);
    getEarmarkTimelineDetails(newPage, selectedItem)
  }
  
  const renderButton = (rowData) => {
    return <CustomButtonSmall
    btnBG={colors.primary[100]}
    btnColor={colors.grey[900]}
    btnTxt={"Add Earmark"}
    btnBorder={"1px solid"+colors.primary[100]}
    onClick={() => handleAddNewEarmarkClick(rowData)}
    ></CustomButtonSmall>
  };

  const handleAddNewEarmarkClick = (rowData) => {
    setSelectedDealerName(rowData.name);
    setSelectedDealerCode(rowData.code);
    setOpenAddEarmarkDialog(true);
    // addNewEarmark();
  };

  // function to add earmark details for new dealers
  async function addNewEarmark(formData) {
    try {
      if (!isNetworkConnectionAvailable) {
        throw new Error(NO_INTERNET_CONNECTION_FOUND);
      }

      setProgressbarText(ADDING_EARMARK);
      setLoading(true);

      const contentData = {
        accountCode: selectedDealerCode,
        accountName: selectedDealerName,
        earmarkAmount: formData.earmark,
        reason: formData.reason,
        transactionDate: null,
        fromDate: null,
        toDate: null,
        pageNumber: null, 
        pageSize: null,
        sortOrder: null,
        sortProperty: null,
        vendorCode: null
      };

      const encryptedContentData = await initializeEncryption(
        contentData,
        getFromLocalStorage(MESSAGE_KEY),
        ApiType.ADD_EARMARK_DETAILS
      );
  
      const requestData = {
        requestId: generateRequestId(),
        loginId: getFromLocalStorage(LOGIN_ID),
        sessionId: getFromLocalStorage(SESSION_ID),
        loginUserName: getFromLocalStorage(USER_NAME),
        contentData: encryptedContentData,
      };

      // Call the API to get filter criteria
      addEarmarkDetails(requestData)
      .then((response) => {
        setLoading(false);
        showErrorAlert("SUCCESS", "Earmark added successfully.");
        
        // load list again
        // setCurrentPage(0);
        setPaginationModel({ pageSize: pageSize, page: 0 });
        searchAllAccountEarmarkDetails(paginationModel.page, paginationModel.pageSize, filter, searchDealerQuery);

        // navigate back to earmark page
        // navigate(CONSTANT.EARMARK_ROUTE);
      }).catch((error) => {
        handleError(error);
      });

    } catch (error) {
      handleError(error);
    }
  }

  function addDealerSearchButtonClicked(instantSearchQuery) {
      console.log('Instant Search Query: ', instantSearchQuery);
      if (
          instantSearchQuery != null &&
          instantSearchQuery != undefined &&
          instantSearchQuery != ''
      ) {
          searchAllAccountEarmarkDetails(
              paginationModel.page,
              paginationModel.pageSize,
              filter,
              instantSearchQuery
          );
      } else if (
          searchDealerQuery != null &&
          searchDealerQuery != undefined &&
          searchDealerQuery != ''
      ) {
          searchAllAccountEarmarkDetails(
              paginationModel.page,
              paginationModel.pageSize,
              filter,
              searchDealerQuery
          );
      } else {
          alert('Please enter value to search for dealer.');
      }
  }



  const handleRowClick = (params) => {
    if (!params.row.addButton) {
      setSelectedItem(params.row);
      setOpenSaveAndRemoveEarmarkDialog(true);
      getEarmarkTimelineDetails(timelineCurrentPage, params.row)
    }
  };

  // update existing earmark details 
  function requestUpdateEarMarkDetailsData(params,earmarkValue,reasonValue) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = {
          accountCode: params.code,
          transactionDate: params.date,
          earmarkAmount: earmarkValue,
          // fromDate: params.fromDate,
          // toDate: params.toDate,
          accountName: params.name,
          reason:reasonValue,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_EARMARKS_DETAILS
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          updateEarMarkDetails(requestData)
            .then((response) => {
              setLoading(false);
              showErrorAlert("SUCCESS", "Earmark updated successfully.");
              // load list again
              // setCurrentPage(0);
              setPaginationModel({ pageSize: pageSize, page: 0 });
              searchAllAccountEarmarkDetails(paginationModel.page, paginationModel.pageSize, filter, searchDealerQuery);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN)
              }
             else 
              if (error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else if (
                error.data.errorCode === ApiErrorCode.UNABLE_TO_PROCESS_ERROR
              ) {
                try {
                  navigate(CONSTANT.FINANCE_DASHBOARD);
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                error.data != null
                  ? error.data.displayErrorMessage
                  : SOME_ERROR_OCCURRED;

              if (message)
                showErrorAlert(
                  ERROR,
                  ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  // remove existing earmark details data
  function requestDeleteEarMarkDetailsData(params,earmarkValue,reasonValue) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = {
          accountCode: params.code,
          transactionDate: params.date,
          earmarkAmount: earmarkValue,
          // fromDate: params.fromDate,
          // toDate: params.toDate,
          accountName: params.name,
          reason: reasonValue,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_EARMARKS_DETAILS
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          deleteEarMarkDetails(requestData)
            .then((response) => {
              setLoading(false);
              showErrorAlert("REMOVED", "Earmark removed successfully.");

              // load list again
              // setCurrentPage(0);
              setPaginationModel({ pageSize: pageSize, page: 0 });
              searchAllAccountEarmarkDetails(paginationModel.page, paginationModel.pageSize, filter, searchDealerQuery);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN)
              }
             else 
              if (error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else if (
                error.data.errorCode === ApiErrorCode.UNABLE_TO_PROCESS_ERROR
              ) {
                try {
                  navigate(CONSTANT.FINANCE_DASHBOARD);
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                error.data != null
                  ? error.data.displayErrorMessage
                  : SOME_ERROR_OCCURRED;

              if (message)
                showErrorAlert(
                  ERROR,
                  ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  function getEarmarkTimelineDetails(pageNo, params) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_TIMELINE);
        setLoading(true);

        const requestObject = {
          pageNumber: pageNo,
          pageSize: timelinePageSize,
          accountCode: params.code,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.EARMARK_DETAILS_AUDIT
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          getEarMarkTimelineDetails(requestData)
            .then((response) => {
              const contentData =
                response.data.result.earmarkAuditDetails.content.map((row) => ({
                  ...row,
                  id: generateRandomId(),
                }));
              setearmarkTimelineDetails(contentData);
              setTimelineTotalNoOfPages(response.data.result.earmarkAuditDetails.totalPages);
              setLoading(false);
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }

  // search accounts after user click search button
  function searchAllAccountEarmarkDetails(
    pageNumber, 
    pageSize,
    selectedFilter, 
    filterValue
  ) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = createRequestObject(
            pageNumber,
            pageSize,
            selectedFilter,
            filterValue
        );

        console.log("Request Object: ", requestObject);

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.ALL_ACCOUNTS_EARMARK_DETAILS
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          getAllAccountsEarMarkDetails(requestData)
            .then((response) => {
              const contentData =
                response.data.result.allAccountEarmarkDetails.content.map((row) => ({
                  ...row,
                  id: generateRandomId(),
                }));
              setEarmarkDetails(contentData);
              setRowsPerPage(response.data.result.allAccountEarmarkDetails.content.length);
              setTotalNoOfRows(response.data.result.allAccountEarmarkDetails.totalElements);
              setTotalNoOfPages(response.data.result.allAccountEarmarkDetails.totalPages);

              setSearchInitiated(true);
              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN)
              }
             else 
              if (error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else if (
                error.data.errorCode === ApiErrorCode.UNABLE_TO_PROCESS_ERROR
              ) {
                try {
                  navigate(CONSTANT.FINANCE_DASHBOARD);
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                error.data != null
                  ? error.data.displayErrorMessage
                  : SOME_ERROR_OCCURRED;

              if (message)
                showErrorAlert(
                  ERROR,
                  ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                );
              }
            });

          setLoading(false);
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  // Create Request Object for searchAllAccountEarmarkDetails API
  function createRequestObject(pageNumber, pageSize, selectedFilter, filterValue) {
    // Initialize all fields to null
    let requestObject = {
      accountCode: null,
      earmarkAmount: null,
      accountName: null,
      pageNumber: pageNumber,
      pageSize: pageSize,
      reason: null,
      sortOrder: null,
      sortProperty: null,
      vendorCode: null
    };
  
    // Set the appropriate field based on filterCriteria
    if (selectedFilter != null && selectedFilter != undefined && selectedFilter.paramName != "") {
      if (filterValue != null && filterValue != undefined && filterValue != "") {
        requestObject[selectedFilter.paramName] = filterValue;
      }
    }

    return requestObject;
  }

  // handle error code reusable block
  function handleError(error) {
    setLoading(false);

    if (error.message === NO_INTERNET_CONNECTION_FOUND) {
      // Handle no internet connection error
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      return;
    } 

    const errorCode = error.data?.errorCode;
    var errorMessage =
        error.response != null
            ? error.displayErrorMessage
            : 'Unknown';
    if (error.data?.displayErrorMessage) {
      errorMessage = error.data.displayErrorMessage;
    }

    const errorActions = {
      [ApiErrorCode.SESSION_EXPIRED]: () => navigate(CONSTANT.LOGIN),
      [ApiErrorCode.SESSION_ID_NOT_FOUND]: () => navigate("/"),
      [ApiErrorCode.UNABLE_TO_PROCESS_ERROR]: () => navigate(CONSTANT.FINANCE_DASHBOARD),
      default: () => showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(errorMessage)
      ),
    };
  
    (errorActions[errorCode] || errorActions.default)();
  }

  function blockNavigation(location, action) {
    // Block navigation if action is "pop", which indicates back/forward button press
    if (action === "pop") {
      // Optionally, you can show a message to the user before blocking navigation
      alert("Back button is disabled.");
      return false;
    }
    return true; // Allow navigation for other actions like "push" or "replace"
  }

  function showErrorAlert(title, content) {
    try {
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };

  return (
      /* Main Container */
      <Box>
          <SnackbarProvider maxSnack={3}>
              <ConnectionStatus />

              <AddEarmarkDialogInput
                  open={openAddEarmarkDialog}
                  onClose={handleClose}
                  dealerName={selectedDealerName}
                  onSubmit={addNewEarmark}
              />

              <ShowErrorAlertDialog
                  status={getDialogStatus}
                  title={title}
                  content={content}
              />

              <SaveAndRemoveEarmarkDialog
                  open={openSaveAndRemoveEarmarkDialog}
                  onClose={handleCloseSaveAndRemoveEarmarkDialog}
                  onDialogButtonClick={requestUpdateEarMarkDetailsData}
                  onDialogRemoveButtonClick={requestDeleteEarMarkDetailsData}
                  data={selectedItem}
                  earmarkTimeline={earmarkTimelineDetails}
                  totalNoOfPages={timelineTotalNoOfPages}
                  onPageChange={handleTimelinePageChange}
              />

              {isNetworkConnectionAvailable ? (
                  <CustomProgressDialog
                      open={loading}
                      text={getProgressbarText}
                  />
              ) : (
                  showNoInternetSnackBar()
              )}
              <Grid
                  container
                  component="main"
                  direction={'column'}
                  sx={{
                      // height: "100vh",
                      m: '0 2.5%' /* Approx 30px */,
                      borderRadius: '18px',
                  }}
              >
                  {/* Header */}
                  <Grid
                      container
                      direction={'row'}
                      alignItems={'center'}
                      mb={2}
                      ml={2}
                      mt={1}
                  >
                      <Grid item mr={2}>
                          <IconButton href={CONSTANT.EARMARK_ROUTE} width={12}>
                              <img
                                  src={'../../assets/common/Back.svg'}
                                  width={12}
                              />
                          </IconButton>
                      </Grid>

                      <Grid item>
                          <Typography
                              color={colors.grey[100]}
                              fontWeight={'600'}
                              variant="h3"
                          >
                              {'Add Dealer'}
                          </Typography>
                      </Grid>

                      <Box position="absolute" right={25} top={90}>
                          <Grid
                              container
                              direction={'row'}
                              alignItems={'center'}
                          >
                              {/* SEARCH BAR */}
                              {isDateFilterSelected ? (
                                  <Box
                                      backgroundColor={colors.grey[900]}
                                      borderRadius="20px"
                                      ml={5}
                                      mr={2}
                                  >
                                      <DatePickerDropdownButton
                                          onDateSelect={(selectedDate) => {
                                              setDealerSearchQuery(
                                                  selectedDate
                                              );
                                              addDealerSearchButtonClicked(
                                                  selectedDate
                                              );
                                          }}
                                      />
                                  </Box>
                              ) : (
                                  <Box
                                      backgroundColor={colors.grey[900]}
                                      borderRadius="20px"
                                      ml={5}
                                      mr={2}
                                  >
                                      <InputBase
                                          sx={{ ml: 2, flex: 1 }}
                                          placeholder={searchQueryPlaceholder}
                                          value={searchDealerQuery}
                                          onChange={(e) =>
                                              setDealerSearchQuery(
                                                  e.target.value
                                              )
                                          }
                                          onKeyDown={(e) => {
                                              if (e.key === 'Enter') {
                                                  addDealerSearchButtonClicked();
                                                  e.preventDefault(); // Prevent form submission & page refresh
                                              }
                                          }}
                                      />

                                      <IconButton
                                          type="button"
                                          sx={{ p: 1 }}
                                          onClick={() => addDealerSearchButtonClicked()}
                                      >
                                          <SearchIcon />
                                      </IconButton>
                                  </Box>
                              )}

                              <ToolbarFilterButton
                                  options={filterDisplayOptions}
                                  defaultOption={defaultFilter}
                                  onChange={handleFilterChange}
                                  name={'FILTERS'}
                              />
                          </Grid>
                      </Box>
                  </Grid>
                  {/* Header */}

                  {/* On Hold Section */}
                  <Grid
                      container
                      mt={3}
                      border={'1px solid' + colors.grey[600]}
                      borderRadius={3}
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      // pb={2}
                  >
                      {/* <SectionHeader
              sectionIcon={"../../assets/common/onhold.svg"}
              sectionHeading={"On Hold"}
            ></SectionHeader> */}

                      {/* only show data after first search was initiated */}
                      {!searchInitiated ? (
                          <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              height="450px"
                              width="100%"
                          >
                              <Typography variant="h6" align="center">
                                  Search results will be displayed here.
                              </Typography>
                          </Box>
                      ) : earmarkDetails.length > 0 ? (
                          <Box
                              borderRadius={3}
                              flex={1}
                              m="0px 0 0 0"
                              pb={0}
                              sx={{
                                  overflow: 'hidden', // Add this to clip the DataGrid's corners
                                  "& .MuiDataGrid-root": {
                                    border: "none",
                                    borderRadius: 'inherit', // Inherit the borderRadius from the Box
                                  },
                                  '& .MuiDataGrid-cell': {
                                      borderBottom: 'none',
                                  },
                                  '& .name-column--cell': {
                                      color: colors.redAccent[200],
                                      fontWeight: 'bold',
                                      fontSize: 13,
                                  },
                                  '& .MuiDataGrid-columnHeaders': {
                                      backgroundColor: 'rgba(255,255,255,0.6)',
                                      borderBottom: 'none',
                                      fontWeight: 'bold',
                                      fontSize: '13px',
                                      color: `${colors.grey[300]} !important`,
                                  },
                                  '& .MuiDataGrid-virtualScroller': {
                                      background: 'rgba(255,255,255,1)',
                                  },
                                  '& .MuiDataGrid-footerContainer': {
                                      borderTop: 'none',
                                      backgroundColor: 'rgba(255,255,255,0.6)',
                                  },
                                  '& .MuiCheckbox-root': {
                                      //color: `${colors.white[200]} !important`,
                                  },
                                  '& .MuiDataGrid-toolbarContainer .MuiButton-text':
                                      {
                                          //  color: `${colors.grey[100]} !important`,
                                          //backgroundColor: "rgba(255,255,255,0.6)",
                                          // opacity:.5
                                      },
                              }}
                          >
                              <DataGrid
                                  rows={earmarkDetails}
                                  columns={allAccountsEarmarkColumnHeader(
                                      renderButton
                                  )}
                                  // components={{ Toolbar: CustomToolbarWithoutExport }}
                                  checkboxSelection={false}
                                  selecion
                                  autoHeight
                                  pageSize={pageSize}
                                  pageSizeOptions={[25, 50, 100]}
                                  rowCount={totalNoOfRows}
                                  paginationModel={paginationModel}
                                  paginationMode="server"
                                  keepNonExistentRowsSelected
                                  onPageChange={handlePageChange}
                                  onPageSizeChange={handlePageSizeChange}
                                  onRowClick={handleRowClick}
                              />
                          </Box>
                      ) : (
                          NoDataFound()
                      )}
                  </Grid>

                  {earmarkDetails.length > 0 ? (
                      <Box margin={2} marginBottom={5}>
                          <Typography>
                              <span>Jump to page: </span>
                              <select
                                  value={paginationModel.page + 1}
                                  onChange={handlePageJump}
                              >
                                  {[...Array(totalNoOfPages)].map(
                                      (_, index) => (
                                          <option key={index} value={index + 1}>
                                              {index + 1}
                                          </option>
                                      )
                                  )}
                              </select>
                          </Typography>
                      </Box>
                  ) : (
                      ''
                  )}
                  <UserActivityInfo />
              </Grid>
          </SnackbarProvider>
      </Box>
      /* Main Container */
  );
}
